import _ from 'underscore';
import React from 'react';
import ReactDOM from 'react-dom';
import { Label, mergeStyleSets, Callout, DirectionalHint } from '@fluentui/react';
import { HelpIcon } from '@bingads-webui-campaign-react/help';
import { PrimaryButton } from '@fluentui/react/lib/Button';
import { NewAdStrengthScore } from '@bingads-webui-campaign-react/responsive-search-ad-suggestion';
import { FontIcon } from '@fluentui/react/lib/Icon';

import { getAdEditorInitializer, getAdEditorInitializerWebpack } from '../../index';
import { getActionItems, getStrengthIcon } from './ad-strength-helper';

function showAdEditor({
  adStrengthEntity, adsGrid,
}) {
  const { Campaign: campaign, AdGroup: adgroup, Type: type } = adStrengthEntity;
  const campaignId = (campaign && campaign.Id) || 0;
  const adGroupId = (adgroup && adgroup.Id) || 0;
  const {
    newI18n,
    IsRSASuggestionCMUIEnabled,
    deps,
    shouldSendOpportunityLog,
    logOpportunity,
    adsTabPerfMarker,
    serverContext,
    preferenceService,
  } = adsGrid;
  const initializer = deps
    ? () => getAdEditorInitializerWebpack(
      true,
      deps.adEditorDependencies
    )
    : getAdEditorInitializer;
  const inlineSuggestionsEnabled =
    type === 'ResponsiveSearch' ?
      IsRSASuggestionCMUIEnabled : false;
  ReactDOM.unmountComponentAtNode(document.querySelector('#rejectionContainer'));
  initializer().then(({ initializeAdEditor }) => {
    initializeAdEditor({
      scope: {
        campaignId,
        adGroupId,
        campaignType: _.result(campaign, 'CampaignType'),
      },
      gridView: adsGrid,
      newI18n,
      item: adStrengthEntity,
      isForVNext: true,
      inlineSuggestionsEnabled,
      shouldSendOpportunityLog,
      logOpportunity,
      perfMarker: adsTabPerfMarker,
      serverContext,
      preferenceService,
    });
  });
}
export function renderSuggestionPopup({
  i18n, event, containerDOM, adStrengthEntity, adsGrid, closeAdStrengthPopup,
}) {
  const {
    AdStrength, AdStrengthActionItems, Id, AdGroup, Campaign, FinalUrls,
  } = adStrengthEntity;
  const { customerId: cid, accountId: aid } = adsGrid.scope;
  const actionItemsStrings = getActionItems({ i18n, actionItems: AdStrengthActionItems }) || [];
  const iconName = getStrengthIcon(AdStrength);
  const styles = mergeStyleSets({
    callout: {
      width: 'fit-content',
      padding: '20px 24px 20px 24px',
      fontSize: '12px',
    },
    pendingcallout: {
      width: 320,
      padding: '20px 24px',
      fontSize: '12px',
    },
    container: {},
    title: {
      marginBottom: 12,
      '& label': {
        fontSize: '20px',
      },
    },
    chart: {
      '& .ad-strength-title': {
        fontWeight: 600,
        fontSize: '14px',
        '& .icon': {
          fontSize: 10,
          marginRight: 4,
          height: 20,
          width: 20,
          lineHeight: '20px',
          fontWeight: 600,
          textAlign: 'center',
          borderRadius: '50%',
        },
        '& .Poor': {
          color: '#BC0505',
          background: '#FDE7E9',
        },
        '& .Average': {
          color: '#D83B01',
          background: '#FFF4CE',
        },
        '& .Good': {
          color: '#107C10',
          background: '#DFF6DD',
        },
        '& .Excellent': {
          color: '#107C10',
          background: '#DFF6DD',
        },
      },
      '& .ad-strength-score-vnext': {
        marginTop: 8,
      },
    },
    body: {
      padding: '10px 0px 0px 0px',
      listStylePosition: 'inside',
    },
    link: {
      fontWeight: '700',
    },
  });

  ReactDOM.render(
    (
      <div onMouseLeave={closeAdStrengthPopup}>
        { AdStrength &&
        <Callout className={`ad-adstrength-callout ${AdStrength === 'Pending' ? styles.pendingcallout : styles.callout}`} target={event.target} directionalHint={DirectionalHint.rightCenter} role="alert" >
          { AdStrength === 'Pending' ?
            <div> {i18n.getString('Ad_Strength_Pending_Message')} </div> :
            <div className={styles.container} block variant="xLarge">
              <div className={styles.title}>
                <Label>
                  {i18n.getString('Ad_Strength_Title')}
                  <HelpIcon topic="pop_BA_RSA_AdStrength" />
                </Label>
              </div>
              <div className={styles.chart}>
                <div className="ad-strength-title">
                  <FontIcon
                    iconName={iconName}
                    className={`icon ${AdStrength}`}
                  />
                  {i18n.getString(`Ad_Strength_${AdStrength}_Performance`)}
                </div>
                <NewAdStrengthScore strength={AdStrength} width={316} />
              </div>
              <ul className={styles.body}>
                {actionItemsStrings.map(item =>
                  <li style={{ lineHeight: '20px', padding: '2px', fontSize: '14px' }} key={item}> {item}</li>)}
              </ul>
              <PrimaryButton
                className={`ad-strength-improve-button ${styles.link}`}
                onClick={() => {
              adsGrid.activityAdStrengthLogger.signal(`ad strength click improve ad - campaignId:{"AdId":"${Id}","OrderId":"${AdGroup.Id}","CampaignId":"${Campaign && Campaign.Id}","cid":"${cid}","aid":"${aid}","FinalUrls": "${FinalUrls && FinalUrls.toString()}","adstrength":"${AdStrength}"}`);
              showAdEditor({
                adsGrid,
                adStrengthEntity,
              });
          }}
              > {i18n.getString('Ad_Strength_Improve_ad')}
              </PrimaryButton>
            </div>
          }
        </Callout>
        }
      </div>
    ),
    containerDOM
  );
}
